<template>
  <div class="row">
    <label
      class="col-md-3 form-col-label control-label"
      :class="{ required: isRequired }"
      >{{ $t('borrowingSparePart.customer') }}</label
    >
    <div class="col-md-7">
      <div class="ts-flex">
        <a-select
          show-search
          v-model="model.customer_id"
          style="width: 100%"
          :default-active-first-option="false"
          :show-arrow="false"
          :filter-option="false"
          :not-found-content="null"
          @search="handleSearch"
          @change="onCustomerChange"
        >
          <a-select-option v-for="c in customerList" :key="c.customer_id">
            {{ c.ss_id_card ? c.ss_id_card + ' |' : '' }} {{ c.customer_name }}
            {{ c.contact_number ? ' |' + c.contact_number : '' }}
          </a-select-option>
        </a-select>
        <!-- <a-select
          v-model="model.customer_id"
          class="ts-w-full"
          :options="customerList"
          showSearch
          :filterOption="
            (input, option) =>
              option.componentOptions.children[0].text
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
          "
          @change="onCustomerChange"
        >
        </a-select> -->
        <a
          href="#"
          class="ts-px-2 ts-bg-blue-600 ts-text-white ts-items-center ts-flex ts-rounded-tr-md ts-rounded-br-md ts-h-8"
          @click.prevent="addNewCustomer"
          ><i class="fas fa-plus"></i
        ></a>
      </div>
      <div class="validate ts-text-xs" v-if="errors.has('customer_id')">
        {{ errors.first('customer_id') }}
      </div>
    </div>
    <a-modal
      v-model="add_customer"
      :title="$t('borrowingSparePart.customer')"
      :footer="null"
      width="350px"
    >
      <ts-loading-banner :loading="loading">
        <div class="ts-space-y-3">
          <div class="row">
            <div class="col-md-12">
              <label class="ts-text-xs required">{{
                $t('customerProfile.customerType')
              }}</label>
              <a-select
                v-model="customerModel.cus_type_id"
                :options="listType"
                showSearch
                :filterOption="
                  (input, option) =>
                    option.componentOptions.children[0].text
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                "
                class="ts-w-full"
              ></a-select>
              <div class="validate ts-text-xs" v-if="errors.has('cus_type_id')">
                {{ errors.first('cus_type_id') }}
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <label class="ts-text-xs required">{{
                $t('customerProfile.customerName')
              }}</label>
              <input
                v-model="customerModel.customer_name"
                type="text"
                class="form-control"
                :class="{ 'is-invalid': errors.has('customer_name') }"
              />
              <div
                class="invalid-feedback ts-text-xs"
                v-if="errors.has('customer_name')"
              >
                {{ errors.first('customer_name') }}
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="ts-w-full">
                <a-radio-group v-model="customerModel.gender">
                  <a-radio value="Male">Male</a-radio>
                  <a-radio value="Female">Female</a-radio>
                </a-radio-group>
              </div>
              <div class="validate ts-text-xs" v-if="errors.has('gender')">
                {{ errors.first('gender') }}
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <label class="ts-text-xs required">{{
                $t('customerProfile.phoneNumber')
              }}</label>
              <input
                v-model.trim="customerModel.contact_number"
                type="text"
                class="form-control"
                :class="{ 'is-invalid': errors.has('contact_number') }"
              />
              <div
                class="invalid-feedback ts-text-xs"
                v-if="errors.has('contact_number')"
              >
                {{ errors.first('contact_number') }}
              </div>
            </div>
          </div>
          <h5 class="ts-uppercase ts-text-gray-500">
            {{ $t('customerProfile.address') }}
          </h5>
          <div class="row">
            <div class="col-md-12">
              <label class="ts-text-xs">{{
                $t('customerProfile.province')
              }}</label>
              <a-select
                v-model="customerModel.province_code"
                :options="provinceList"
                @change="onProvinceChange"
                showSearch
                :filterOption="
                  (input, option) =>
                    option.componentOptions.children[0].text
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                "
                class="ts-w-full"
              ></a-select>
              <div
                class="validate ts-text-xs"
                v-if="errors.has('province_code')"
              >
                {{ errors.first('province_code') }}
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <label class="ts-text-xs">{{
                $t('customerProfile.district')
              }}</label>
              <a-select
                v-model="customerModel.district_code"
                :options="districts"
                showSearch
                @change="onDistrictChange"
                :filterOption="
                  (input, option) =>
                    option.componentOptions.children[0].text
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                "
                class="ts-w-full"
              ></a-select>
              <div
                class="validate ts-text-xs"
                v-if="errors.has('district_code')"
              >
                {{ errors.first('district_code') }}
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <label class="ts-text-xs">{{
                $t('customerProfile.commune')
              }}</label>
              <a-select
                v-model="customerModel.commune_code"
                :options="communes"
                showSearch
                @change="onCommuneChange"
                :filterOption="
                  (input, option) =>
                    option.componentOptions.children[0].text
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                "
                class="ts-w-full"
              ></a-select>
              <div
                class="validate ts-text-xs"
                v-if="errors.has('commune_code')"
              >
                {{ errors.first('commune_code') }}
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <label class="ts-text-xs">{{
                $t('customerProfile.village')
              }}</label>
              <a-select
                v-model="customerModel.village_code"
                :options="villages"
                showSearch
                :filterOption="
                  (input, option) =>
                    option.componentOptions.children[0].text
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                "
                class="ts-w-full"
              ></a-select>
              <div
                class="validate ts-text-xs"
                v-if="errors.has('village_code')"
              >
                {{ errors.first('village_code') }}
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <label class="ts-text-xs">{{
                $t('borrowingSparePart.engineNumber')
              }}</label>
              <input
                v-model="model.engine_number"
                type="text"
                class="form-control"
                :class="{ 'is-invalid': errors.has('engine_number') }"
              />
              <div
                class="invalid-feedback ts-text-xs"
                v-if="errors.has('engine_number')"
              >
                {{ errors.first('engine_number') }}
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 ts-mt-3 text-right">
              <ts-button
                class="mr-2"
                @click.prevent="() => (add_customer = false)"
              >
                {{ $t('cancel') }}
              </ts-button>
              <ts-button color="primary" @click.prevent="onSave">{{
                $t('save')
              }}</ts-button>
            </div>
          </div>
        </div>
      </ts-loading-banner>
    </a-modal>

    <a-modal
      v-model="show_engine"
      :title="$t('borrowingSparePart.engineNumber')"
      :footer="null"
    >
      <table class="ts-w-full ts-mt-3">
        <tbody>
          <tr
            v-for="(engine, index) in engineNumberList"
            :key="index"
            class="ts-border-b hover:ts-bg-gray-100 ts-cursor-pointer"
            @click="chosenEngine(engine)"
          >
            <td class="ts-py-2 ts-px-3">
              <div style="line-height: 1.25">
                <p class="ts-mb-0">{{ engine.product_name_kh }}</p>
                <p class="ts-mb-0">{{ engine.engine_number }}</p>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </a-modal>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import { Errors } from 'form-backend-validation'
import { debounce } from 'lodash'
export default {
  name: 'customerSelect',
  props: ['value', 'validate'],
  data() {
    return {
      show_engine: false,
      add_customer: false,
      errors: new Errors(),
      loading: false,
      model: {},
      districts: [],
      engineNumberList: [],
      communes: [],
      villages: [],
      customerModel: {
        customer_id: 0,
        cus_type_id: null,
        customer_name: null,
        gender: null,
        contact_number: null,
        contact_email: null,
        facebook_account: null,
        city_province: null,
        year_of_born: null,
        account_number: null,
        is_general_customer: false,
        is_membership: false,
        is_allow_update_gps_location: false,
        membership_discount_rate: 0,
        company_name: null,
        zip_code: null,
        credit_day: 0,
        credit_amount: 0,
        province_code: null,
        disctrict_code: null,
        commune_code: null,
        village_code: null,
        sale_id: null,
        ss_id_card: null,
        gis_location: ''
      }
    }
  },
  created() {
    this.model = this.value
  },
  computed: {
    ...mapState('wholesale/borrowingSparePart', ['formModels']),
    customerList() {
      if (!this.formModels.customer) return []
      return this.formModels.customer
      // .filter(f => f.cus_type_id == this.cus_type_id)
      // .map(el => ({
      //   value: el.customer_id,
      //   label: el.customer_name
      // }))
    },
    provinceList() {
      return this.$store.state.customer.profile.provinces.map(el => ({
        value: el.province_code,
        label: el.name_en
      }))
    },
    listType() {
      return this.$store.state.customer.profile.customerType.map(el => ({
        value: el.cus_type_id,
        label: el.customer_type
      }))
    },
    isRequired() {
      return (
        this.model.product_detail.find(p => p.type_number === 2) !== undefined
      )
    }
  },
  methods: {
    ...mapActions('customer/profile', [
      'getDistrict',
      'getCommune',
      'getVillage'
    ]),
    ...mapActions('wholesale/borrowingSparePart', [
      'findEngine',
      'getFormViewData'
    ]),
    onChangeCustomerType() {
      this.model.customer_id = null
      this.model.engine_number = null
    },
    addNewCustomer() {
      this.add_customer = true
      this.clearInput()
      this.model.engine_number = null
      this.fetchResources()
    },
    fetchResources() {
      this.loading = true
      this.$store.dispatch('customer/profile/fetchResources').finally(() => {
        this.loading = false
      })
    },
    onSave() {
      // if (!this.model.engine_number) {
      //   this.$toasted.error('Please provide engine number before save')
      //   return 0
      // }
      this.loading = true
      this.$store
        .dispatch('customer/profile/store', this.customerModel)
        .then(response => {
          this.$store.commit('wholesale/borrowingSparePart/PUSH_NEW_CUSTOMER', {
            cus_type_id: this.customerModel.cus_type_id,
            customer_id: response.data.customer_id,
            customer_name: response.data.customer_name
          })
          this.model.customer_id = response.data.customer_id
          this.add_customer = false
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.loading = false
        })
    },
    async onProvinceChange(value, opt) {
      this.model.disctrict_code = null
      this.model.commune_code = null
      this.model.village_code = null
      this.loading = true
      await this.getDistrict(value)
        .then(response => {
          this.districts = response.data.map(el => ({
            value: el.district_code,
            label: el.name_en
          }))
        })
        .finally(() => {
          this.loading = false
        })
    },
    async onDistrictChange(value, opt) {
      this.model.commune_code = null
      this.model.village_code = null
      this.loading = true
      await this.getCommune(value)
        .then(response => {
          this.communes = response.data.map(el => ({
            value: el.commune_code,
            label: el.name_en
          }))
        })
        .finally(() => {
          this.loading = false
        })
    },
    async onCommuneChange(value, opt) {
      this.model.village_code = null
      this.loading = true
      await this.getVillage(value)
        .then(response => {
          this.villages = response.data.map(el => ({
            value: el.village_code,
            label: el.name_en
          }))
        })
        .finally(() => {
          this.loading = false
        })
    },
    clearInput() {
      this.customerModel.customer_id = 0
      this.customerModel.cus_type_id = null
      this.customerModel.customer_name = null
      this.customerModel.gender = null
      this.customerModel.contact_number = null
      this.customerModel.contact_email = null
      this.customerModel.facebook_account = null
      this.customerModel.city_province = null
      this.customerModel.year_of_born = null
      this.customerModel.account_number = null
      this.customerModel.is_general_customer = false
      this.customerModel.is_membership = false
      this.customerModel.is_allow_update_gps_location = false
      this.customerModel.membership_discount_rate = 0
      this.customerModel.company_name = null
      this.customerModel.zip_code = null
      this.customerModel.credit_day = 0
      this.customerModel.credit_amount = 0
      this.customerModel.province_code = null
      this.customerModel.disctrict_code = null
      this.customerModel.commune_code = null
      this.customerModel.village_code = null
      this.customerModel.sale_id = null
      this.customerModel.ss_id_card = null
      this.customerModel.gis_location = ''
    },
    onCustomerChange(customerId) {
      this.$emit('change', customerId)
      // find product engine number by customer
      this.$emit('loading', true)
      this.findEngine(customerId)
        .then(response => {
          this.engineNumberList = response.data
          if (response.data.length) {
            this.show_engine = true
          }
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.$emit('loading', false)
        })
    },
    chosenEngine(engine) {
      this.model.engine_number = engine.engine_number
      this.model.product_name = engine.product_name_kh
      this.model.product_id = engine.product_id
      this.show_engine = false
    },
    handleSearch: debounce(async function(value) {
      this.$emit('loading', true)
      await this.getFormViewData({
        index: 'customer',
        params: {
          fnName: 'customer',
          search_customer: value
        }
      })
      this.$emit('loading', false)
    }, 800)
  },
  watch: {
    validate: function(error) {
      this.errors = new Errors(error.errors)
    }
  }
}
</script>
